import { render } from "./UserManagmentView.vue?vue&type=template&id=3734c940&scoped=true"
import script from "./UserManagmentView.vue?vue&type=script&lang=js"
export * from "./UserManagmentView.vue?vue&type=script&lang=js"

import "./UserManagmentView.vue?vue&type=style&index=0&id=3734c940&lang=css"
import "./UserManagmentView.vue?vue&type=style&index=1&id=3734c940&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3734c940"]])

export default __exports__